<template>
  <div class="station-list">
    <div v-if="stations.length === 0" class="empty">暂无充电站，点击上方按钮添加</div>
    <div
      v-for="st in stations"
      :key="st.id"
      class="station-card"
      :class="{ active: st.id === selectedId }"
      @click="$emit('select', st)"
    >
      <div class="card-head">
        <div class="st-name">{{ st.name }}</div>
        <div class="card-badges">
          <div v-if="st.maxPower" class="st-power">
            <span class="power-num">{{ st.maxPower }}</span>
            <span class="power-label">kW</span>
          </div>
          <div class="st-stalls">
            <span class="stalls-num">{{ st.totalStalls }}</span>
            <span class="stalls-label">充电桩</span>
          </div>
        </div>
      </div>
      <div class="st-address">{{ st.address }}</div>
      <table class="tariff-table">
        <thead>
          <tr>
            <th>时段</th>
            <th>类型</th>
            <th>价格<span class="unit">（元/度）</span></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="t in st.tariffs"
            :key="t.period + t.label"
            :class="{ 'now': isCurrent(t) }"
          >
            <td>{{ t.period }}</td>
            <td>
              <span class="tag" :class="tagClass(t.label)">{{ t.label }}</span>
            </td>
            <td class="price">¥{{ t.price.toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>
      <div class="card-actions">
        <template v-if="editable">
          <button class="btn-mini" @click.stop="$emit('edit', st)">编辑</button>
          <button class="btn-mini danger" @click.stop="$emit('remove', st)">删除</button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StationList',
  props: {
    stations: { type: Array, required: true },
    selectedId: { type: String, default: '' },
    editable: { type: Boolean, default: false }
  },
  emits: ['select', 'edit', 'remove'],
  methods: {
    tagClass(label) {
      if (label.includes('峰')) return 'peak'
      if (label.includes('谷')) return 'valley'
      return 'flat'
    },
    isCurrent(tariff) {
      const now = new Date()
      const mins = now.getHours() * 60 + now.getMinutes()
      const [start, end] = tariff.period.split('-').map(p => {
        const [h, m] = p.trim().split(':').map(Number)
        return h * 60 + m
      })
      return mins >= start && mins < end
    }
  }
}
</script>

<style scoped>
.station-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 12px;
  align-items: start;
}
.empty {
  grid-column: 1 / -1;
  text-align: center;
  color: #94a3b8;
  padding: 40px 0;
  font-size: 14px;
}
.station-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 14px;
  cursor: pointer;
  transition: box-shadow 0.2s, border-color 0.2s;
}
.station-card:hover {
  border-color: #2563eb;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.12);
}
.station-card.active {
  border-color: #2563eb;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
}
.card-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.card-badges {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}
.st-power {
  text-align: center;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  padding: 4px 10px;
  min-width: 46px;
}
.power-num {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #ea580c;
}
.power-label {
  font-size: 11px;
  color: #c2410c;
}
.st-name {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}
.st-stalls {
  text-align: center;
  background: #f1f5f9;
  border-radius: 8px;
  padding: 4px 10px;
  min-width: 52px;
}
.stalls-num {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: #2563eb;
}
.stalls-label {
  font-size: 11px;
  color: #64748b;
}
.st-address {
  font-size: 12px;
  color: #64748b;
  margin: 6px 0 8px;
}
.tariff-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.tariff-table th {
  text-align: left;
  color: #94a3b8;
  font-weight: 500;
  padding: 3px 4px;
  border-bottom: 1px solid #f1f5f9;
}
.tariff-table td {
  padding: 3px 4px;
  color: #334155;
  border-bottom: 1px solid #f8fafc;
}
.tariff-table tr.now td {
  background: #eff6ff;
  font-weight: 600;
}
.tag {
  display: inline-block;
  padding: 0 6px;
  border-radius: 4px;
  font-size: 11px;
}
.tag.peak { background: #fee2e2; color: #dc2626; }
.tag.valley { background: #dcfce7; color: #16a34a; }
.tag.flat { background: #e0e7ff; color: #4f46e5; }
.price {
  font-weight: 600;
  color: #1e293b;
}
.card-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}
.btn-mini {
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  cursor: pointer;
}
.btn-mini.danger:hover {
  border-color: #dc2626;
  color: #dc2626;
}

/* 手机（<=640px） */
@media (max-width: 640px) {
  .station-list {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .station-card {
    padding: 10px 12px;
  }
  .st-name {
    font-size: 14px;
  }
  .stalls-num {
    font-size: 16px;
  }
  .tariff-table {
    font-size: 11px;
  }
  .unit {
    display: none;
  }
  .btn-mini {
    padding: 6px 14px;
  }
}
</style>
